var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.items.length === 0},scopedSlots:_vm._u([{key:`item.queueName`,fn:function({ item }){return [_c('span',{staticClass:"pointer primary--text",on:{"click":function($event){return _vm.$emit('click', item)}}},[_vm._v(_vm._s(item.queueName))])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }